import { DOCTYPES } from '@/constants/doctypes.ts'
import { PERMISSIONS } from '@/constants/permissions.ts'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeConnectedAppCreate,
  detail: routeConnectedAppDetail,
  home: routeConnectedAppHome,
  root: routeConnectedAppRoot,
} = createDoctypeRoutes({
  createName: 'new-connected-app',
  createPath: 'new-connected-app',
  detailName: 'connected-app-detail',
  doctype: DOCTYPES.CONNECTED_APP,
  extraListDoctypes: { [DOCTYPES.TW_EMAIL_CONFIG]: [PERMISSIONS.READ] },
  homeName: 'connected-app',
  path: 'connected-app',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/settings/email/connectedApp/AddConnectedApp.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/settings/email/connectedApp/ViewConnectedApp.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/email/ViewEmailSettings.vue'),
  },
})

export {
  routeConnectedAppCreate,
  routeConnectedAppDetail,
  routeConnectedAppHome,
  routeConnectedAppRoot,
}
